import _ from "lodash";
import { roundValue } from "src/util/decimal-utils";

export const parsedItems = (items) => {
  return items
    .map((item) => {
      try {
        return typeof item === "string" ? JSON.parse(item) : item;
      } catch (e) {
        console.error("Failed to parse item:", item, e);
        return null;
      }
    })
    .filter((item) => item !== null);
};

export const addSubTasksToSections = (sections, subTasks) => {
  if (!subTasks || subTasks.length === 0 || _.isEmpty(sections))
    return sections;
  const subTaskMap = new Map();
  subTasks.forEach((subTask) => {
    if (!subTaskMap.has(subTask.taskId)) {
      subTaskMap.set(subTask.taskId, []);
    }
    const parsedMaterial = parsedItems(subTask.material);
    const parsedLabor = parsedItems(subTask.labor);
    const parsedSubContractor = parsedItems(subTask.subcontractor);
    const materialSaleAmount = parsedMaterial.reduce(
      (sum, item) => sum + roundValue(item.total || 0),
      0
    );
    const laborSaleAmount = parsedLabor.reduce(
      (sum, item) => sum + roundValue(item.total || 0),
      0
    );
    const subcontractorSaleAmount = parsedSubContractor.reduce(
      (sum, item) => sum + roundValue(item.saleAmount || 0),
      0
    );

    subTask.totalSaleAmount = roundValue(
      roundValue(materialSaleAmount, 2) +
        roundValue(laborSaleAmount, 2) +
        roundValue(subcontractorSaleAmount, 2)
    );
    subTaskMap.get(subTask.taskId).push(subTask);
  });

  const updatedSections = Object.fromEntries(
    Object.entries(sections).map(([sectionId, section]) => {
      if (!section.taskList || !section.taskList.tasks) {
        return [sectionId, { ...section }];
      }

      const updatedTasks = Object.fromEntries(
        Object.entries(section.taskList.tasks).map(([taskId, task]) => {
          if (subTaskMap.has(taskId)) {
            const updatedTask = {
              ...task,
              subTasks: [...subTaskMap.get(taskId)],

              materialSaleAmount: roundValue(
                subTaskMap
                  .get(taskId)
                  .reduce((sum, st) => sum + (st.materialSaleAmount || 0), 0)
              ),
              laborSaleAmount: roundValue(
                subTaskMap
                  .get(taskId)
                  .reduce((sum, st) => sum + (st.laborSaleAmount || 0), 0)
              ),
              subcontractorSaleAmount: roundValue(
                subTaskMap
                  .get(taskId)
                  .reduce(
                    (sum, st) => sum + (st.subcontractorSaleAmount || 0),
                    0
                  )
              ),
            };
            updatedTask.totalSaleAmount =
              roundValue(updatedTask.materialSaleAmount) +
              roundValue(updatedTask.laborSaleAmount) +
              roundValue(updatedTask.subcontractorSaleAmount);
            return [taskId, updatedTask];
          }
          return [taskId, { ...task }];
        })
      );

      return [
        sectionId,
        {
          ...section,
          taskList: {
            ...section.taskList,
            tasks: updatedTasks,
          },
        },
      ];
    })
  );

  return updatedSections;
};

export const addSubTasksToOptions = (optionList, subTasks) => {
  if (!subTasks || subTasks.length === 0 || _.isEmpty(optionList))
    return optionList;
  const subTaskMap = new Map();
  subTasks.forEach((subTask) => {
    if (!subTaskMap.has(subTask.taskId)) {
      subTaskMap.set(subTask.taskId, []);
    }
    const parsedMaterial = parsedItems(subTask.material);
    const parsedLabor = parsedItems(subTask.labor);
    const parsedSubContractor = parsedItems(subTask.subcontractor);
    const materialSaleAmount = parsedMaterial.reduce(
      (sum, item) => sum + roundValue(item.total || 0),
      0
    );
    const laborSaleAmount = parsedLabor.reduce(
      (sum, item) => sum + roundValue(item.total || 0),
      0
    );
    const subcontractorSaleAmount = parsedSubContractor.reduce(
      (sum, item) => sum + roundValue(item.saleAmount || 0),
      0
    );
    subTask.totalSaleAmount =
      roundValue(materialSaleAmount, 2) +
      roundValue(laborSaleAmount, 2) +
      roundValue(subcontractorSaleAmount, 2);
    subTaskMap.get(subTask.taskId).push(subTask);
  });

  const updatedOptionList = Object.fromEntries(
    Object.entries(optionList).map(([optionId, option]) => {
      if (subTaskMap.has(optionId)) {
        const updatedOption = {
          ...option,
          subTasks: [...subTaskMap.get(optionId)],
          materialSaleAmount: roundValue(
            subTaskMap
              .get(optionId)
              .reduce((sum, st) => sum + (st.materialSaleAmount || 0), 0)
          ),
          laborSaleAmount: roundValue(
            subTaskMap
              .get(optionId)
              .reduce((sum, st) => sum + (st.laborSaleAmount || 0), 0)
          ),
          subcontractorSaleAmount: roundValue(
            subTaskMap
              .get(optionId)
              .reduce((sum, st) => sum + (st.subcontractorSaleAmount || 0), 0)
          ),
        };
        updatedOption.totalSaleAmount =
          roundValue(updatedOption.materialSaleAmount) +
          roundValue(updatedOption.laborSaleAmount) +
          roundValue(updatedOption.subcontractorSaleAmount);
        return [optionId, updatedOption];
      }
      return [optionId, { ...option }];
    })
  );

  return updatedOptionList;
};
